// =============================================================================
// Origin UI — src/services/helpAdminApi.ts
// Typed API calls for help assistant admin (KB CRUD + feedback management).
// =============================================================================

import { api } from './apiService';

export interface KnowledgeBaseListItem {
  knowledgeBaseId: string;
  title: string;
  sortOrder: number;
  isActive: boolean;
  lastEditedBy: string;
  lastEditedAt: string;
}

export interface KnowledgeBaseDetail {
  knowledgeBaseId: string;
  title: string;
  sortOrder: number;
  content: string;
  isActive: boolean;
  lastEditedBy: string;
  lastEditedAt: string;
  createdAt: string;
}

export interface CreateKnowledgeBaseDto {
  title: string;
  sortOrder: number;
  content: string;
  isActive: boolean;
}

export interface UpdateKnowledgeBaseDto {
  title: string;
  sortOrder: number;
  content: string;
  isActive: boolean;
}

export interface FeedbackListItem {
  feedbackId: string;
  userQuestion: string;
  assistantResponse: string;
  userRole: string;
  userDisplayName: string;
  createdAt: string;
  isReviewed: boolean;
  reviewedBy: string | null;
  reviewedAt: string | null;
  reviewNotes: string | null;
}

export const helpAdminApi = {
  // Knowledge Base
  listKnowledgeBase: () =>
    api.get<KnowledgeBaseListItem[]>('/api/admin/help/knowledge-base'),

  getKnowledgeBase: (id: string) =>
    api.get<KnowledgeBaseDetail>(`/api/admin/help/knowledge-base/${id}`),

  createKnowledgeBase: (dto: CreateKnowledgeBaseDto) =>
    api.post<KnowledgeBaseDetail>('/api/admin/help/knowledge-base', dto),

  updateKnowledgeBase: (id: string, dto: UpdateKnowledgeBaseDto) =>
    api.put<void>(`/api/admin/help/knowledge-base/${id}`, dto),

  deleteKnowledgeBase: (id: string) =>
    api.delete<void>(`/api/admin/help/knowledge-base/${id}`),

  // Feedback
  listFeedback: (filter?: string) =>
    api.get<FeedbackListItem[]>(`/api/admin/help/feedback${filter ? `?filter=${filter}` : ''}`),

  reviewFeedback: (id: string, reviewNotes: string) =>
    api.put<void>(`/api/admin/help/feedback/${id}/review`, { reviewNotes }),

  deleteFeedback: (id: string) =>
    api.delete<void>(`/api/admin/help/feedback/${id}`),
};
